"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const playlists_1 = require("../../api/playlists");
const PlaylistsComponent_1 = __importDefault(require("../../components/playlists/PlaylistsComponent"));
const add_png_1 = __importDefault(require("../../resources/img/add.png"));
const delete_png_1 = __importDefault(require("../../resources/img/delete.png"));
const PlaylistButtonComponent_1 = __importDefault(require("../../components/playlists/PlaylistButtonComponent"));
const CreatePlaylistModalService_1 = __importDefault(require("./CreatePlaylistModalService"));
const DeletePlaylistModalService_1 = __importDefault(require("../tracklist/DeletePlaylistModalService"));
const ModelStatus_1 = require("../../types/ModelStatus");
const PlaylistCardPresenter_1 = __importDefault(require("./PlaylistCardPresenter"));
const notInitialized_1 = require("../../utils/notInitialized");
class PlaylistsPresenter {
    constructor(parentElement, playlistsModel, modalService) {
        this.parentElement = parentElement;
        this.playlistsModel = playlistsModel;
        this.changeToPlaylist = notInitialized_1.notInitialized;
        this.playlistsComponent = new PlaylistsComponent_1.default(playlistsModel);
        this.createPlaylistModalService = new CreatePlaylistModalService_1.default(modalService);
        this.deletePlaylistModalService = new DeletePlaylistModalService_1.default(modalService, playlistsModel);
        this.loadPlaylists();
    }
    async loadPlaylists() {
        this.playlistsModel.playlists = await (0, playlists_1.loadPlaylistsData)();
        this.playlistsModel.status = ModelStatus_1.ModelStatus.Success;
        this.playlistsModel.onChange();
    }
    render() {
        this.playlistsComponent.removeElement();
        const playlistsComponentElement = this.playlistsComponent.getElement();
        const listElement = playlistsComponentElement.querySelector('.playlist__list');
        this.parentElement.append(playlistsComponentElement);
        if (!listElement) {
            throw new Error('element with a class ".playlist__list" is not found');
        }
        listElement.innerHTML = '';
        for (const playlist of this.playlistsModel.playlists) {
            new PlaylistCardPresenter_1.default(listElement, playlist, this.changeToPlaylist);
        }
        this.addCreatePlaylistComponent(listElement);
        this.addDeletePlaylistComponent(listElement);
    }
    addCreatePlaylistComponent(listElement) {
        const createPlaylistComponent = new PlaylistButtonComponent_1.default(add_png_1.default, 'Создать плейлист');
        createPlaylistComponent.addOnClickListener((event) => {
            event.preventDefault();
            this.createPlaylistModalService.open(async (name) => {
                const newPlaylist = await (0, playlists_1.createPlaylist)(name);
                this.playlistsModel.add(newPlaylist);
                this.createPlaylistModalService.close();
                this.playlistsModel.onChange();
            });
        });
        listElement.append(createPlaylistComponent.getElement());
    }
    addDeletePlaylistComponent(listElement) {
        const deletePlaylistComponent = new PlaylistButtonComponent_1.default(delete_png_1.default, 'Удалить плейлист');
        deletePlaylistComponent.addOnClickListener((event) => {
            event.preventDefault();
            this.deletePlaylistModalService.open(async (playlistId) => {
                await (0, playlists_1.deletePlaylist)(playlistId);
                this.playlistsModel.delete(playlistId);
                this.deletePlaylistModalService.close();
                this.playlistsModel.onChange();
            });
        });
        listElement.append(deletePlaylistComponent.getElement());
    }
}
exports.default = PlaylistsPresenter;
